export default __webpack_public_path__ + "static/media/陳駿丞.b9882dd8.jpg";